import React, { useEffect, useState } from "react";
import ConnectionCard from "../../Components/ConnectionCard";
import SideBar from "../../Components/Sidebar";
import { useSelector } from "react-redux";
import "../../Styles/ConnectionPage.css";
import { getConnections } from "../../Services/Connection";
import { getCachedConnections } from "../../Data/dataStore";
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CommunityProfileCard from "../Container/Community/CommunityProfileCard";
import ViewMore from "./../../Assests/View More.svg"
import { setValue, setSearchUserData, clearSearchUserData, setUserMessage, setIsChatOpen } from "../../redux/valueSlice";
import { setProfileShow } from "../../redux/notificationSlice";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Vector from "./../../Assests/scrollToTop.png"
import AddUsers from "./../../Assests/Add User.svg"
import { getUserProfile } from "../../Services/ShowsApi";
import { API_STATUS, CONNECTIONS_TYPE } from "../../utils/constant";
import { useLoader } from "../../Components/LoaderContext";
import {
  CometChat,
} from "@cometchat/chat-sdk-javascript";
import { getPendingConnections } from "../../Services/Connection";
import { acceptConnectionRequests, rejectConnectionRequests } from "../../Services/SchedulesApi";
import ToggleTypeSelector from "../../Components/ToggleTypeSelector";
import PropTypes from 'prop-types';

const ConnectionPage = ({ viewAll: propViewAll, setViewAll: propSetViewAll }) => {
  const location = useLocation();
  const isChatOpen = useSelector((state) => state.value?.isChatOpen);
  // All hooks at the top
  const [internalViewAll, setInternalViewAll] = useState(false);
  const viewAll = propViewAll !== undefined ? propViewAll : internalViewAll;
  const setViewAll = propSetViewAll !== undefined ? propSetViewAll : setInternalViewAll;
  const cachedData = getCachedConnections();
  const [connections, setConnections] = useState(cachedData?.nonStarredConnections || []);
  const [favConnections, setFavConnections] = useState(cachedData?.starredConnections || []);
  const [allConnections, setAllConnections] = useState(cachedData?.allConnections || []);
  
  const [error, setError] = useState(null);
  const [requests, setRequests] = useState([]);
  const [selectedTab, setSelectedTab] = useState(CONNECTIONS_TYPE[0].type);
  
  // Pagination states
  const [displayedConnections, setDisplayedConnections] = useState([]);
  const [displayedRequests, setDisplayedRequests] = useState([]);
  const [connectionsPage, setConnectionsPage] = useState(1);
  const [requestsPage, setRequestsPage] = useState(1);
  const [hasMoreConnections, setHasMoreConnections] = useState(true);
  const [hasMoreRequests, setHasMoreRequests] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [isActionPopupOpen, setIsActionPopupOpen] = useState(false);

  // Check if we're navigating from profile menu with viewAll state
  useEffect(() => {
    if (location.state?.viewAll && propViewAll === undefined) {
      setInternalViewAll(true);
    }
  }, [location.state, propViewAll]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const info = useSelector((state) => state.info);
  const value = useSelector((state) => state?.value)

  const limit = viewAll ? 1000 : 3; // Set high limit to get all connections
  const { triggerLoader, hideLoader } = useLoader();

  const fetchPendingConnections = async (page = 1, isLoadMore = false) => {
    try {
      const { data } = await getPendingConnections();
      const { nonStarredConnections = [] } = data;
      
      if (isLoadMore) {
        // Append new requests to existing ones
        setRequests(prev => [...prev, ...nonStarredConnections]);
      } else {
        // Reset requests for new search
        setRequests(nonStarredConnections);
        setRequestsPage(1);
      }
      
      // Check if there are more requests to load (assuming 12 per page)
      setHasMoreRequests(nonStarredConnections.length === 12);
      
    } catch (error) {
      console.error("Failed to fetch pending connections:", error);
    }
  };

  const handleAcceptRequest = async (connection) => {
    console.log(`Approved user: ${connection.UserID}`);
    const payload = {
      "SenderID": connection.UserID,
      "ReceiverID": localStorage.getItem('user_id'),
      "Status": "ACCEPTED"
    };
    try {
      await acceptConnectionRequests(payload);
      await fetchPendingConnections();
      await fetchConnections();
      // Refresh the page to show latest status
      dispatch(setValue({ searchPageLoad: !value?.searchPageLoad }));
    } catch (error) {
      console.error("Failed to accept request:", error);
    }
  };

  const handleDeclineRequest = async (connection) => {
    console.log(`Declined user: ${connection.UserID}`);
    const payload = {
      "SenderID": connection.UserID,
      "ReceiverID": localStorage.getItem('user_id'),
      "Status": "REJECTED"
    };
    try {
      await rejectConnectionRequests(payload);
      await fetchPendingConnections();
      await fetchConnections();
      // Refresh the page to show latest status
      dispatch(setValue({ searchPageLoad: !value?.searchPageLoad }));
    } catch (error) {
      console.error("Failed to decline request:", error);
    }
  };


  useEffect(() => {
    fetchConnections();
    fetchPendingConnections();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [value?.searchPageLoad]); // Remove 'limit' from dependency

  // Additional effect to refresh connections when needed
  // useEffect(() => {
  //   if (value?.searchPageLoad !== undefined) {
  //     fetchConnections();
  //     fetchPendingConnections();
  //   }
  // }, [value?.searchPageLoad]);

  // Update fetchConnections to use correct page and limit
  const fetchConnections = async (page = 1, isLoadMore = false) => {
    const userId = localStorage.getItem("user_id");
    if (!userId) {
      setError("User is not logged in");
      return;
    }
    try {
      // Use backend pagination: 12 per page for allConnections
      const response = await getConnections(userId, 1, 12, page, 12);
      const { starredConnections = [], nonStarredConnections = [], starredConnectionCount = 0, nonStarredConnectionCount = 0, allConnections: apiAllConnections = [] } = response || {};
      
      const combinedConnections = apiAllConnections.length > 0 ? apiAllConnections : [...starredConnections, ...nonStarredConnections];
      
      if (isLoadMore) {
        setAllConnections(prev => [...prev, ...combinedConnections]);
      } else {
        setAllConnections(combinedConnections);
        setConnectionsPage(1);
      }
      // Optionally, keep starred/nonStarred for other tabs
      setConnections(nonStarredConnections);
      setFavConnections(starredConnections);
      // Check if there are more connections to load
      setHasMoreConnections(combinedConnections.length === 12);
    } catch (err) {
      console.error("Error fetching connections:", err);
      setError("Failed to fetch connections.");
    }
  };

  const scrollToTop = () => {
    const container = document.querySelector(viewAll ? '.hide-scrollbar' : '.container-fluid');
    if (container) {
      container.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  };

  const handleViewAll = () => {
    setViewAll(true);
  };

  const goBack = () => {
    setViewAll(false);
  };

  // Set default tab to 'All Connections' when viewAll is activated
  useEffect(() => {
    if (viewAll) {
      setSelectedTab('All Connections');
    }
  }, [viewAll]);

  // Reset pagination when tab changes
  useEffect(() => {
    if (viewAll) {
      setConnectionsPage(1);
      setRequestsPage(1);
      setHasMoreConnections(true);
      setHasMoreRequests(true);
      // Refetch data for the selected tab
      if (selectedTab === 'All Connections') {
        fetchConnections(1, false);
      } else if (selectedTab === 'Requests') {
        fetchPendingConnections(1, false);
      }
    }
  }, [selectedTab, viewAll]);

  if (error) {
    return <div className="error-container">{error}</div>;
  }

  const handleClickViewProfile = async (creater) => {
    triggerLoader("Loading profile...")
    dispatch(clearSearchUserData())
    const res = await getUserProfile(creater?.UserID);

    if (res?.status == API_STATUS.success) {
      let { body } = res?.data
      let { Data } = body
      //passing selected userData
      dispatch(setValue({ 
        viewSearchProfile: true,
        viewFromRequests: selectedTab === 'Requests'
      }))
      dispatch(setSearchUserData(Data[0]))

      //profile popupmaking visible
      dispatch(setProfileShow(true));
      hideLoader()
    }
  }

  const handleConnectionClick = async (id) => {
    dispatch(setIsChatOpen(true))
    // Fetch friends
    const usersRequest = new CometChat.UsersRequestBuilder()
      .friendsOnly(true)
      .setLimit(50)
      .build();

    const connections = await usersRequest.fetchNext();
    console.log("connections", connections)

    //The code enables a user to initiate a chat with a selected user.
    let selectedUser = connections.find((user) => user.uid === id);
    dispatch(setUserMessage([selectedUser]))
  }

  const handleAddConnection = () => {
    dispatch(setValue({ requestShow: true }))
  }

  const handleLoadMoreConnections = async () => {
    setIsLoadingMore(true);
    const nextPage = connectionsPage + 1;
    setConnectionsPage(nextPage);
    await fetchConnections(nextPage, true);
    setIsLoadingMore(false);
  };

  const handleLoadMoreRequests = async () => {
    setIsLoadingMore(true);
    const nextPage = requestsPage + 1;
    setRequestsPage(nextPage);
    await fetchPendingConnections(nextPage, true);
    setIsLoadingMore(false);
  };

  // Store first 3 connections for Recent Connections
  const recentConnections = allConnections.slice(0, 3);

  // Update ConnectionsGrid for 'All Connections' tab
  const ConnectionsGrid = ({ title, connections, emptyMessage, showLoadMore = false, onLoadMore, hasMore, isLoading }) => (
    <>
      {title && (
        <div className="connection-header">
          <div className="connection-header-title">
            <h2>{title}</h2>
          </div>
        </div>
      )}
      <div className={`connection-cards-container ${!viewAll && isActionPopupOpen ? 'action-popup-open' : ''}`} style={viewAll ? {paddingTop: "0vh"} : {}}>
        <div className="connections-grid">
          {connections?.length > 0 ? (
            connections.map((connection) => (
              <CommunityProfileCard
                key={connection.Email}
                userConnection={true}
                creater={connection}
                handleClickViewProfile={handleClickViewProfile}
                handleConnectionClick={handleConnectionClick}
                fetchConnections={fetchConnections}
                showInterests={false}
                onActionPopupToggle={setIsActionPopupOpen}
              />
            ))
          ) : (
            <div className={viewAll ? "no-connection-wrapper" : "no-connection-wrapper-inline"}>
              <div className="no-connection-message">{emptyMessage}</div>
            </div>
          )}
        </div>
        {showLoadMore && hasMore && connections?.length > 12 && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '2.4vh', marginBottom: '3.2vh', width: '100%' }}>
          <button
            type="button"
            onClick={onLoadMore}
            disabled={isLoading}
            style={{
              width: '17.4vh',
              height: '4.6vh',
              background: '#2968FECC',
              color: '#fff',
              border: 'none',
              borderRadius: '1.6vh',
              padding: '0.8vh 3.2vh',
              fontSize: '2vh',
              fontWeight: '500',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              opacity: isLoading ? 0.7 : 1,
              transition: 'all 0.2s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.8vh'
            }}
            onMouseEnter={(e) => {
              if (!isLoading) {
                e.target.style.background = '#3A7AFFCC';
              }
            }}
            onMouseLeave={(e) => {
              if (!isLoading) {
                e.target.style.background = '#2968FECC';
              }
            }}
          >
            {isLoading ? 'Loading...' : 'Load More'}
          </button>
        </div>
      )}
      </div>
    </>
  );
  console.log("requests", requests?.length);

  return (
    <div>
      <div className={`connections-page-layout ${!viewAll && isActionPopupOpen ? 'action-popup-open' : ''}`} 
      style={
            viewAll
              ? {
                  height: 'calc(75vh)',
                  overflowY: 'auto',
                  display: 'flex',
                  flexDirection: 'column',
                }
              : {}
          }>
        {/* Header and Recent Connections or Your Connections */}
        {!viewAll ? (
          <>
            <div className="connection-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div className="connection-header-title">
                <h2>Recent Connections</h2>
              </div>
              <button
                type="button"
                className="connectionpage_view-all-button pointer"
                onClick={handleViewAll}
                style={{ display: 'flex', alignItems: 'center', gap: '0.8vh', background: 'none', padding: '0.8vh 1.6vh', margin: 0, cursor: 'pointer' }}
              >
                <span>View All</span>
                <img src={ViewMore} alt="icon" />
              </button>
            </div>
            <ConnectionsGrid
              title=""
              connections={recentConnections}
              emptyMessage="No connections found."
              viewAll={viewAll}
            />
          </>
        ) : (
          <div className="connection-header" style={{display: 'flex', alignItems: 'center', gap: '0.8vh', marginBottom: '1.6vh', position: "sticky",top: 0, zIndex: 10,}}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <button
                type="button"
                className="connection-left-arrow"
                onClick={goBack}
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', marginRight: '0.8vh', background: 'none', border: 'none', padding: 0, margin: 0 }}
              >
                <ArrowBackIosIcon />
              </button>
              <h2>Your Connections</h2>
            </div>
          </div>
        )}

        {/* Show toggle and tab content if viewAll */}
        {viewAll && (
          <>
            <div style={{ marginBottom: '1.6vh', width: '100%' ,position: "sticky",zIndex: 10}}>
              <ToggleTypeSelector
                TYPE_Items={CONNECTIONS_TYPE}
                handleSearchTypeChange={setSelectedTab}
                toggleType={selectedTab}
                requestCount={requests?.length || 0}
              />
            </div>
            <div className={viewAll ? "hide-scrollbar" : ""}>
                {selectedTab === 'All Connections' && (
                  <ConnectionsGrid
                    title=""
                    connections={allConnections}
                    emptyMessage="No connections found."
                    showLoadMore={true}
                    onLoadMore={handleLoadMoreConnections}
                    hasMore={hasMoreConnections}
                    isLoading={isLoadingMore}
                    viewAll={viewAll}
                  />
                )}
                {selectedTab === 'Favorites' && (
                  <ConnectionsGrid
                    title=""
                    connections={favConnections}
                    emptyMessage="No favorites found. Explore and add important connections to your favorites!"
                    viewAll={viewAll}
                  />
                )}
                {selectedTab === 'Requests' && (
                  <>
                    <div className="connection-cards-container">
                      <div className="connections-grid">
                        {requests?.length > 0 ? (
                          requests.map((connection) => (
                            <CommunityProfileCard
                              key={connection.Email}
                              userConnection={true}
                              creater={connection}
                              handleClickViewProfile={handleClickViewProfile}
                              handleConnectionClick={handleConnectionClick}
                              fetchConnections={fetchConnections}
                              type="request"
                              onAccept={() => handleAcceptRequest(connection)}
                              onDecline={() => handleDeclineRequest(connection)}
                            />
                          ))
                        ) : (
                          <div className={viewAll ? "no-connection-wrapper" : "no-connection-wrapper-inline"}>
                            <div className="no-connection-message">No pending requests</div>
                          </div>
                        )}
                      </div>
                    </div>
                    {hasMoreRequests && requests?.length > 12 && (
                      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2.4vh' }}>
                        <button
                          type="button"
                          onClick={handleLoadMoreRequests}
                          disabled={isLoadingMore}
                          style={{
                            background: 'rgba(41, 104, 254, 0.8)',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '0.8vh',
                            padding: '1.2vh 2.4vh',
                            fontSize: '1.6vh',
                            fontWeight: '500',
                            cursor: isLoadingMore ? 'not-allowed' : 'pointer',
                            opacity: isLoadingMore ? 0.7 : 1,
                            transition: 'opacity 0.2s'
                          }}
                        >
                          {isLoadingMore ? 'Loading...' : 'Load More'}
                        </button>
                      </div>
                    )}
                  </>
                )}
            </div>
          </>
        )}
      </div>
      {!isChatOpen && viewAll && (
      <button
        type="button"
        className="scroll-top-button"
        onClick={scrollToTop}
        style={{ backgroundColor: 'rgba(24, 119, 242, 0.32)', border: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
      >
        <img src={Vector} alt="Scroll to top" />
      </button> 
      )}
    </div>
  );
};

export default ConnectionPage;

ConnectionPage.propTypes = {
  viewAll: PropTypes.bool,
  setViewAll: PropTypes.func,
};